export default {
  state: {
    defaultData: {},
  },

  getters: {
    getPostoData(state) {
      return state.defaultData;
    },
  },

  mutations: {
    setPostoData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        county_reference_id: !isNull ? Number(data.county_reference_id) : "",
        module_id: !isNull ? Number(data.module_id) : ""
      };
    },
  },

  actions: {
    changePostoData(context, infos) {
      context.commit("setPostoData", infos);
    },
  },
};
